import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, Container, DropdownItem } from 'reactstrap';
import NeedsReviewFilterSwitch from './NeedsReviewFilterSwitch';
import IsMarkedCompletedFilterSwitch from './IsMarkedCompletedFilterSwitch';
import HasCommentsFilterSwitch from './HasCommentsFilterSwitch';
import { useSelector, shallowEqual } from 'react-redux';
import hasPermission from '../../../../../../../Shared/hasPermission';

const MappingStateFilters = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canReadComments = hasPermission('CodeMapsCommentsRead', permissions);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    return (
        <div style={{
            overflow: 'hidden'
        }}>
            <Dropdown
                isOpen={dropdownOpen}
                toggle={toggleDropdown}
                className="text-center">
                <DropdownToggle caret size="sm">
                    State Filters
                </DropdownToggle>
                <DropdownMenu container="body" right style={{ minWidth: '350px', zIndex: 9999 }}>
                    <NeedsReviewFilterSwitch />
                    <IsMarkedCompletedFilterSwitch />
                    {canReadComments && <HasCommentsFilterSwitch />}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

export default MappingStateFilters;
